import { Box, Button } from "@mui/material";
import {
  downloadPrintableClassList,
  exportClassListPDF,
} from "../utils/classListExport";

function ClassesActionsPanel({
  canSave,
  canExport,
  rows,
  selectedYear,
  selectedCampus,
  onSave,
  onCopyFromPreviousWeek,
  canCopyFromPreviousWeek,
  copying,
}) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 100,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Button variant="contained" onClick={onSave} disabled={!canSave}>
        Save Changes
      </Button>

      {onCopyFromPreviousWeek && (
        <Button
          variant="outlined"
          onClick={onCopyFromPreviousWeek}
          disabled={!canCopyFromPreviousWeek || copying}
        >
          {copying ? "Copying..." : "Copy from previous week"}
        </Button>
      )}

      <Button
        variant="outlined"
        onClick={() => downloadPrintableClassList(rows, selectedYear)}
        disabled={!canExport}
      >
        Download Class List
      </Button>

      <Button
        variant="outlined"
        onClick={() => exportClassListPDF(rows, selectedYear, selectedCampus)}
        disabled={!canExport}
      >
        Download Class List PDF
      </Button>
    </Box>
  );
}

export default ClassesActionsPanel;
